import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import TranslationNS from '@/utils/Constants/TranslationNS'
import EventHubDialog, {
    EVENT_HUB_DIALOG_BUTTON_CLASS,
    EVENT_HUB_DIALOG_DANGER_CLASS,
    EVENT_HUB_DIALOG_GHOST_CLASS,
    EVENT_HUB_DIALOG_PRIMARY_CLASS,
    EVENT_HUB_DIALOG_Z,
    EventHubDialogActions,
} from './EventHubDialog'

/**
 * Titled destructive prompt (mock `#confirmDlg`): the question is the title, an
 * optional line of consequences underneath, then "Keep it" (focused by default, so
 * Enter never destroys anything) beside the red action. Sits above every other
 * dialog. Rendered while open; the owner unmounts it from `onCancel` / `onConfirm`.
 */
export default function EventHubConfirmDialog({
    title,
    text,
    confirmLabel,
    cancelLabel,
    onConfirm,
    onCancel,
    // 'danger' (red, something is lost) or 'primary' (ink: a confirmed action that loses nothing)
    tone = 'danger',
    // keeps the action inert until the owner's own gate passes (a "I have downloaded…" checkbox)
    confirmDisabled = false,
    children,
}) {
    const { t } = useTranslation(TranslationNS.EVENT_PAGE)
    const refuseRef = useRef(null)

    return (
        <EventHubDialog
            id="event-hub-confirm-dialog"
            title={title}
            zClass={EVENT_HUB_DIALOG_Z.CONFIRM}
            width="sm"
            closable={false}
            initialFocusRef={refuseRef}
            onClose={onCancel}
        >
            {text && <p className="m-0 text-sm leading-[1.45] text-[#5b5f6e]">{text}</p>}
            {children}
            <EventHubDialogActions>
                <button
                    ref={refuseRef}
                    type="button"
                    onClick={onCancel}
                    className={`${EVENT_HUB_DIALOG_BUTTON_CLASS} ${EVENT_HUB_DIALOG_GHOST_CLASS}`}
                >
                    {cancelLabel || t('Keep it')}
                </button>
                <button
                    type="button"
                    onClick={onConfirm}
                    disabled={confirmDisabled}
                    className={`${EVENT_HUB_DIALOG_BUTTON_CLASS} ${
                        tone === 'primary' ? EVENT_HUB_DIALOG_PRIMARY_CLASS : EVENT_HUB_DIALOG_DANGER_CLASS
                    }`}
                >
                    {confirmLabel}
                </button>
            </EventHubDialogActions>
        </EventHubDialog>
    )
}
